import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { InventarioService } from 'src/app/services/inventario.service';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-listadodereporteslentes',
  templateUrl: './listadodereporteslentes.component.html',
  styleUrls: ['./listadodereporteslentes.component.css']
})
export class ListadodereporteslentesComponent implements OnInit {

  lentes: any = [];
  lentespagados: any = [];
  resultados: any = [];

  tipoReporte: string = 'nopagado';
  fechaInicio: any = '';
  fechaFin: any = '';

  datos = JSON.parse(localStorage.getItem('datos')!);
  idplantel = this.datos.idplantel;

  constructor(
    private inventarioService: InventarioService,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {
    this.getLentesCompuExcel();
    this.getLentesPagadosCompuExcel();
  }

  getLentesCompuExcel() {
    this.inventarioService.getListaLentesExcel(this.idplantel)
      .subscribe(res => this.lentes = res);
  }

  getLentesPagadosCompuExcel() {
    this.inventarioService.getListaLentesPagadoExcel(this.idplantel)
      .subscribe(res => this.lentespagados = res);
  }

  // VALIDACIÓN + FILTRADO
  buscarReportes() {

    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire({
         icon: 'warning',
      title: 'Faltan fechas',
      text: 'Debes seleccionar fecha de inicio y fecha de fin para realizar la búsqueda.',
      timer: 1800,
      showConfirmButton: false
      });
      return;
    }

    let origen = [];

    if (this.tipoReporte === 'nopagado') origen = this.lentes;
    else if (this.tipoReporte === 'pagado') origen = this.lentespagados;
    else if (this.tipoReporte === 'todos') origen = [...this.lentes, ...this.lentespagados];

    const inicio = new Date(this.fechaInicio);
    const fin = new Date(this.fechaFin);

    this.resultados = origen.filter((item: any) => {
      const fecha = new Date(item.fecha_factura || item.fecha_pago);
      return fecha >= inicio && fecha <= fin;
    });

    console.log("Registros filtrados:", this.resultados.length);
  }

  exportarExcel() {
    this.excelService.exportAsExcelFile(this.resultados, 'Reporte Lentes Filtrado');
  }

}
